module.exports = __webpack_public_path__ + "static/sala-de-reanimacao-8fa2af80e7995d52ad7c431c1c03181f.jpg";